import React, { useState } from 'react';
import PropertiesList from './DemoPropertyList';
import './Properties.css';
import Footer from './components/Footer';

const characteristicsList = [
  { id: 'location', name: 'Location', url: './imgs/icons/location.png' },
  { id: 'commute', name: 'Commute', url: './imgs/icons/price.png' },
  { id: 'size', name: 'Size', url: './imgs/icons/size.png' },
  { id: 'outside-space', name: 'Outside Space', url: './imgs/icons/outside-space.png' },
  { id: 'parking', name: 'Parking', url: './imgs/icons/parking.png' },
  { id: 'bath', name: 'Bath', url: './imgs/icons/bath.png' },
  { id: 'bedroom', name: 'Bedroom', url: './imgs/icons/bedroom.png' },
  { id: 'garden', name: 'Garden', url: './imgs/icons/fireplace.png' },
  { id: 'curb-appeal', name: 'Curb Appeal', url: './imgs/icons/curb-appeal.png' },
  { id: 'transport', name: 'Transport', url: './imgs/icons/transport.png' },
  { id: 'lease', name: 'Lease', url: './imgs/icons/lease.png' },
  { id: 'freehold', name: 'Freehold', url: './imgs/icons/freehold.png' },
  { id: 'schools', name: 'Schools', url: './imgs/icons/schools.png' },
  { id: 'xfactor', name: 'X-Factor', url: './imgs/icons/xfactor.png' },
  { id: 'storage', name: 'Storage', url: './imgs/icons/storage.png' },
  { id: 'natural-light', name: 'Natural Light', url: './imgs/icons/natural-light.png' }
];

const initialCharacteristics = {
  location: 10,
  size: 8,
  commute: 6,
};

const demoProperties = [
  { url: 'https://example.com/property1', property_name: 'Gresham Street, E17', price: '£325,000', property_image: './imgs/demo_house1.jpeg', ranking: 85, scores: { location: 9, size: 7, commute: 8 } },
  { url: 'https://example.com/property2', property_name: 'Marlington Place, E11', price: '£345,950', property_image: './imgs/demo_house2.jpeg', ranking: 72, scores: { location: 7, size: 6, commute: 7 } },
  { url: 'https://example.com/property3', property_name: 'High Road, TN22', price: '£425,000', property_image: './imgs/demo_house3.jpeg', ranking: 90, scores: { location: 0, size: 0, commute: 0 } },
  { url: 'https://example.com/property4', property_name: 'The Battleys, E14', price: '395,000', property_image: './imgs/demo_house4.jpeg', ranking: null, scores: { location: 0, size: 0, commute: 0 } },
  { url: 'https://example.com/property5', property_name: 'Long Road North, SE12', price: '£350,000', property_image: './imgs/demo_house5.jpeg', ranking: null, scores: { location: 0, size: 0, commute: 0 } },
];

function Demo() {
  const [properties, setProperties] = useState(demoProperties);
  const [selectedCharacteristics, setSelectedCharacteristics] = useState(initialCharacteristics);
  const [showCharacteristicsModal, setShowCharacteristicsModal] = useState(false);
  const [showAddPropertyModal, setShowAddPropertyModal] = useState(false);
  const [hasAddedProperty, setHasAddedProperty] = useState(false);

  const handleAddProperty = () => {
    const newProperty = {
      url: 'https://example.com/propert6',
      property_name: 'New Prop Lane, IP11',
      price: '£375,000',
      property_image: './imgs/demo_house6.jpeg',
      ranking: null,
      scores: { location: 0, size: 0, commute: 0 },
    };
    setProperties([...properties, newProperty]);
    setHasAddedProperty(true);
    setShowAddPropertyModal(false);
  };

  return (
    <div className="properties-page">
      <header className="properties-header">
         <a href='./' style={{height:'20px',}}><img src='/imgs/domorango.png'  alt="My" className="header-logo" /></a>
        <div className='demo-sign-up-button'><a href='create-account'>CREATE AN ACCOUNT FOR FREE</a></div>
      </header>

      <div className='properties-content'>
        <div className='list-of-properties'>
          <h3 className='list-title'>Take Domogogo for a test drive - How does it work?</h3>
          <p style={{paddingTop:'10px'}}>Welcome, explore how our ranking system works. You can update the characteristics that you would find most important to you in your property search and even try scoring some properties. Interested in adding your own properties? <a href='create-account'>Sign up here for free</a></p>
          <hr/>
          <div className='button-group' style={{marginTop:"10px"}}>
            <button className="property-action-button" onClick={() => setShowAddPropertyModal(true)} style={{marginRight:"10px"}} disabled={hasAddedProperty}>ADD PROPERTY</button>
            <button className="property-action-button" onClick={() => setShowCharacteristicsModal(true)}>UPDATE CHARACTERISTICS</button>
          </div>
           <PropertiesList 
            properties={properties} 
            selectedCharacteristics={selectedCharacteristics}
            onUpdateCharacteristics={setSelectedCharacteristics} 
          />
          <div className='sign-up-bottom'>
            <div className='sign-up-bottom-button'>
              <a href='create-account'>CREATE YOUR FREE ACCOUNT</a>
            </div>
          </div>
        </div>
      </div>

      {showCharacteristicsModal && (
  <div
    className="modal-overlay"
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    }}
  >
    <div className="modal-content">
      {/* Panels container */}
      <div className="modal-panels">
        {/* Left Panel - Selecting Characteristics */}
        <div className="left-panel" style={{ display: "flex", flexWrap: "wrap" }}>
          <h3 style={{ marginBottom: "16px" }}>Select characteristics important to your search</h3>
          {characteristicsList.map((char) => (
            <button
              key={char.id}
              className={`toggle-button ${selectedCharacteristics[char.id] ? "on" : "off"}`}
              style={{
                whiteSpace: "nowrap",
                padding: "4px 8px",
                borderRadius: "16px",
                marginRight: "8px",
                marginBottom: "8px",
                backgroundColor: selectedCharacteristics[char.id] ? "white" : "white",
                color: selectedCharacteristics[char.id] ? "black" : "black",
                display: "flex",
                alignItems: "center",
              }}
              onClick={(e) => {
                e.preventDefault();
                setSelectedCharacteristics((prev) => {
                  const updated = { ...prev };
                  if (updated[char.id]) {
                    delete updated[char.id];
                  } else {
                    updated[char.id] = 1; // Default score
                  }
                  return updated;
                });
              }}
            >
              {char.url && (
                <img
                  src={char.url}
                  alt={`${char.name} icon`}
                  style={{
                    width: "24px",
                    height: "24px",
                    marginRight: "8px",
                  }}
                />
              )}
              {char.name}
            </button>
          ))}
        </div>

        {/* Right Panel - Adjusting Importance Sliders */}
        <div className="right-panel">
          <div style={{ width: "100%" }}>
            <h3>And how important are they to you?</h3>
          </div>
          <div className="slider-container" style={{paddingTop:'58px'}}>
            {Object.entries(selectedCharacteristics).map(([id, score]) => (
              <div
                key={id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "10px",
                }}
              >
                <span
                  style={{
                    flex: "0 0 120px",
                    textAlign: "right",
                    marginRight: "10px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                  title={characteristicsList.find((char) => char.id === id)?.name}
                >
                  {characteristicsList.find((char) => char.id === id)?.name}
                </span>
                <div style={{ position: "relative", width: "100%" }}>
                  <input
                    className="char-slider"
                    type="range"
                    min="1"
                    max="10"
                    value={score}
                    onChange={(e) => {
                      const newValue = Number(e.target.value);
                      setSelectedCharacteristics((prev) => ({
                        ...prev,
                        [id]: newValue,
                      }));
                      e.target.style.background = `linear-gradient(to right, #6867FF 0%, #6867FF ${((newValue - 1) / 9) * 100}%, #DDDDDD ${((newValue - 1) / 9) * 100}%, #DDDDDD 100%)`;
                    }}
                    style={{
                      position: "relative",
                      zIndex: "2",
                      background: `linear-gradient(to right, #6867FF 0%, #6867FF ${
                        ((selectedCharacteristics[id] - 1) / 9) * 100
                      }%, #DDDDDD ${((selectedCharacteristics[id] - 1) / 9) * 100}%, #DDDDDD 100%)`,
                      appearance: "none",
                      height: "2px",
                    }}
                  />
                  {/* Invisible touch area */}
                  <div
                    style={{
                      position: "absolute",
                      top: "-10px",
                      bottom: "-10px",
                      left: "0",
                      right: "0",
                      zIndex: "1",
                      cursor: "pointer",
                    }}
                    onClick={(e) => {
                      const rect = e.target.getBoundingClientRect();
                      const clickX = e.clientX - rect.left;
                      const newValue = Math.round((clickX / rect.width) * 9 + 1);
                      setSelectedCharacteristics((prev) => ({
                        ...prev,
                        [id]: newValue,
                      }));
                    }}
                  ></div>
                </div>
                <div style={{ width: "30px", textAlign: "center" }}>
                  <span>{score}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom Bar - Save and Cancel Buttons */}
      <div className="modal-buttons">
        <button className="save-button" onClick={() => setShowCharacteristicsModal(false)}>
          Save
        </button>
        <button className="cancel-button" onClick={() => setShowCharacteristicsModal(false)}>
          Cancel
        </button>
      </div>
    </div>
  </div>
)}

{showAddPropertyModal && (
        <div className="modal-overlay">
          <div className="add-prop-modal">
            <h2>Add a New Property</h2>
            <input type="text" value="https://www.rightmove.co.uk/dummy_property" disabled style={{width:'100%'}}/>
            <div className="modal-buttons">
              <button className="save-button" onClick={handleAddProperty}>ADD PROPERTY</button>
              <button className="cancel-button" onClick={() => setShowAddPropertyModal(false)}>CANCEL</button>
            </div>
          </div>
        </div>
      )}



      <Footer />
    </div>
  );
}

export default Demo;
